<div class="min-[500px]:tw-w-[400px] tw-w-[300px]">
  <!-- title -->
  <app-modal-title
    [title]="'common.smsPreview' | translate"
    [isShowClose]="true"
    (isCloseModal)="onClose()"
  ></app-modal-title>

  <nav
    ngbNav
    #nav="ngbNav"
    class="nav-tabs tw-flex tw-justify-center tw-h-[41px] border-bottom tw-text-center"
    [destroyOnHide]="false"
    [activeId]="selectedMode"
    (activeIdChange)="onChangeMode($event)"
  >
    <!-- ios -->
    <ng-container [ngbNavItem]="'ios'">
      <a
        ngbNavLink
        class="tw-flex-center border bg-transparent"
        style="flex: 1"
        [matTooltip]="'common.iosPreview' | translate"
      >
        <i class="mdi mdi-apple-ios text-info tw-mr-1 mdi-24px"></i>
      </a>

      <!-- ios Mobile -->
      <ng-template ngbNavContent>
        <div class="tw-flex-center">
          <app-sms-preview-mobile
            [senderNumber]="senderNumber"
            [smsBody]="smsBody"
          ></app-sms-preview-mobile>
        </div>
      </ng-template>
    </ng-container>

    <!-- android -->
    <ng-container [ngbNavItem]="'android'">
      <a
        ngbNavLink
        class="tw-flex-center border bg-transparent"
        style="flex: 1"
        [matTooltip]="'common.androidPreview' | translate"
      >
        <i class="mdi mdi-android text-success tw-mr-1 mdi-24px"></i>
      </a>

      <!-- 1 -->
      <ng-template ngbNavContent>
        <!-- android Mobile -->
        <div class="tw-flex-center">
          <app-sms-preview-mobile
            [senderNumber]="senderNumber"
            [smsBody]="smsBody"
            [isIosMobile]="false"
          ></app-sms-preview-mobile>
        </div>
      </ng-template>
    </ng-container>
  </nav>
  <div [ngbNavOutlet]="nav" class="tw-mt-2"></div>
</div>
